import CloverMakeEditsModal from './components/CloverMakeEditsModal';
import CloverPublishModal from './components/CloverPublishModal';
import PublishModal from './components/PublishModal';
import RequestEditModal from './components/RequestEditModal';
var publishModalComponentFromCollectionMethod = {
  CloverMarketplace: CloverPublishModal
};
var requestEditModalComponentFromCollectionMethod = {
  CloverMarketplace: CloverMakeEditsModal
};
var publishModalPropsFromCollectionMethod = {
  CloverMarketplace: function CloverMarketplace(_ref) {
    var state = _ref.state,
      handlePublishOpen = _ref.handlePublishOpen,
      handlePublishClose = _ref.handlePublishClose;
    return {
      open: state.showPublishModal,
      onOpen: handlePublishOpen,
      onClose: handlePublishClose
    };
  }
};
var getDefaultPublishModalProps = function getDefaultPublishModalProps(_ref2) {
  var props = _ref2.props,
    state = _ref2.state,
    handlePublishOpen = _ref2.handlePublishOpen,
    handlePublishClose = _ref2.handlePublishClose,
    onCheckoutCompleted = _ref2.onCheckoutCompleted;
  return {
    showPublishModal: state.showPublishModal,
    handlePublishOpen: handlePublishOpen,
    handlePublishClose: handlePublishClose,
    onCheckoutCompleted: onCheckoutCompleted,
    business: props.business,
    defaultDomain: props.defaultDomain,
    checkedOut: state.checkedOut,
    collectEmail: props.collectEmail,
    domains: state.domains
  };
};
export function getPublishModalPropsFromCollectionMethod(collectionMethod, component) {
  var propsGetter = publishModalPropsFromCollectionMethod[collectionMethod] || getDefaultPublishModalProps;
  return propsGetter(component);
}
export function getPublishModalComponentFromCollectionMethod(collectionMethod) {
  return publishModalComponentFromCollectionMethod[collectionMethod] || PublishModal;
}
var RequestEditModalPropsFromCollectionMethod = {
  CloverMarketplace: function CloverMarketplace(_ref3) {
    var state = _ref3.state,
      handleRequestOpen = _ref3.handleRequestOpen,
      handleRequestClose = _ref3.handleRequestClose;
    return {
      open: state.showRequestEditModal,
      onOpen: handleRequestOpen,
      onClose: handleRequestClose
    };
  }
};
var getDefaultRequestEditModalProps = function getDefaultRequestEditModalProps(_ref4) {
  var props = _ref4.props,
    state = _ref4.state,
    handleRequestOpen = _ref4.handleRequestOpen,
    handleRequestClose = _ref4.handleRequestClose,
    handlePublishOpen = _ref4.handlePublishOpen;
  return {
    open: state.showRequestEditModal,
    onOpen: handleRequestOpen,
    onClose: handleRequestClose,
    handlePublishOpen: handlePublishOpen,
    business: props.business,
    showRequesterInformation: props.showRequesterInformation
  };
};
export function getRequestEditModalPropsFromCollectionMethod(collectionMethod, component) {
  var propsGetter = RequestEditModalPropsFromCollectionMethod[collectionMethod] || getDefaultRequestEditModalProps;
  return propsGetter(component);
}
export function getRequestEditModalComponentFromCollectionMethod(collectionMethod) {
  return requestEditModalComponentFromCollectionMethod[collectionMethod] || RequestEditModal;
}